import { HttpRequestPost } from "./../../service/index";
import DispatchedOrders from "../symbols/dispatchedOrders";
import { roleName } from "../../utils/roles";
import { IOrderFilter } from "./pendingOrders";
type GetOrdersRequestModel = {
  Filter: IOrderFilter;
  OrderBy: string;
  Query: string;
  Page: number;
  Size: number;
};
const dispatchedOrdersAction = () => ({
  type: DispatchedOrders.DISPATCHED_ORDERS,
});
const dispatchedOrdersSuccessAction = (data: any) => ({
  type: DispatchedOrders.DISPATCHED_ORDERS_SUCCESS,
  payload: data,
});
const dispatchedOrdersFailureAction = (data: any) => ({
  type: DispatchedOrders.DISPATCHED_ORDERS_FAILURE,
  payload: data,
});
const clearDispatchedOrdersAction = () => ({
  type: DispatchedOrders.CLEAR_DISPATCHED_ORDERS,
});

export function getDispatchedOrders(
  data?: GetOrdersRequestModel,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    let url = `/${roleName().toLowerCase()}/deliveries/archived`;
    dispatch(dispatchedOrdersAction());
    HttpRequestPost(
      url,
      dispatch,
      dispatchedOrdersSuccessAction,
      dispatchedOrdersFailureAction,
      true,
      data || {
        Query: "",
        Filter: { Status: [] },
        OrderBy: "desc",
      },
      callback
    );
  };
}

export function clearDispatchedOrders() {
  return (dispatch: any) => {
    dispatch(clearDispatchedOrdersAction());
  };
}
